import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useFeedbackHttp } from '@/core/api/feedback'
import { Feedback, FeedbackPayload } from '@/core/models/feedback'

export type FeedbackCollection = {
    data: Array<Feedback>,
    meta?: MetaPayload,
    links?: any
}

const state: FeedbackCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const feedbackCollection: Module<FeedbackCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: FeedbackCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: FeedbackPayload) => {
                state.data.push(new Feedback(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useFeedbackHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: FeedbackCollection): FeedbackCollection => {
            return state
        }
    }
}